import {ChangeDetectionStrategy, Component, computed, Injectable, input, signal} from '@angular/core';
import {AgendaelementModellDLM} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {TranslateModule} from "@ngx-translate/core";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {BeslutningDatatjeneste} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {AgendaelementId, BeslutningModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Observable} from "rxjs";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {switchMap} from "rxjs/operators";
import {beslutningsforslag, endeligeBeslutninger} from "felles-ng2/modell/beslutningModellHjelpere";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {BeslutningListevisningProtokollKomponent} from "web-ng2/moduler/beslutning/komponenter/beslutning-listevisning-protokoll/beslutning-listevisning-protokoll";
import {AjsRouterLinkDirektiv} from "web-ng2/delt/direktiver/ajsRouterLink/ajsRouterLink";

const debug = initDebugger('MøteprotokollSaksreferatKomponent');

@Component({
    selector: 'moeteprotokoll-saksreferat',
    templateUrl: 'møteprotokoll-saksreferat.html',
    styleUrl: 'møteprotokoll-saksreferat.scss',
    host: {
        'class': 'print-unngå-sidebrekk sak',
        'data-testid': 'protokollsak'
    },
    imports: [
        TranslateModule,
        HtmlFormatertKomponent,
        BeslutningListevisningProtokollKomponent,
        AjsRouterLinkDirektiv
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollSaksreferatKomponent {

    sak = input.required<AgendaelementModellDLM>();

    viserForslagTilBeslutninger = signal(false);
    forslagTilBeslutninger = computed(() => beslutningsforslag(this.alleBeslutninger()));
    beslutninger = computed(() => endeligeBeslutninger(this.alleBeslutninger()));

    private alleBeslutninger = toSignal(toObservable(this.sak).pipe(
      switchMap(sak => this.avhengigheter.hentBeslutninger(sak.id))
    ), {initialValue: []});

    constructor(private avhengigheter: MøteprotokollSaksreferatKomponentAvhengigheter, private navigasjon:Navigasjon) {
    }

    visForslag() {
        this.viserForslagTilBeslutninger.set(true);
    }

    skjulForslag() {
        this.viserForslagTilBeslutninger.set(false);
    }
}


@Injectable()
export class MøteprotokollSaksreferatKomponentAvhengigheter {
    constructor(private beslutningDatatjeneste: BeslutningDatatjeneste) {
    }

    hentBeslutninger(sakId: AgendaelementId): Observable<BeslutningModell[]> {
        return this.beslutningDatatjeneste.finnTilknyttetSakFraLokallager(sakId);
    }
}
